// extracted by mini-css-extract-plugin
export var brand = "_t-9";
export var button = "_t-0";
export var chevron = "_t-v";
export var chevronButton = "_t-w";
export var content = "_t-n";
export var danger = "_t-g";
export var dangerOutlined = "_t-h";
export var dark = "_t-l";
export var darkTheme = "_t-c";
export var extraSmall = "_t-4";
export var fullWidth = "_t-8";
export var ghost = "_t-d";
export var gray = "_t-t";
export var icon = "_t-p";
export var iconButton = "_t-s";
export var iconButtonBorder = "_t-x";
export var iconButtonBorderDark = "_t-y";
export var iconButtonBorderLight = "_t-z";
export var iconLeft = "_t-q";
export var iconRight = "_t-r";
export var large = "_t-1";
export var light = "_t-m";
export var medium = "_t-2";
export var micro = "_t-5";
export var nano = "_t-7";
export var outlined = "_t-k";
export var pending = "_t-a";
export var primary = "_t-i";
export var shadow = "_t-o";
export var small = "_t-3";
export var solidLight = "_t-e";
export var solidLightBrand = "_t-f";
export var spinner = "_t-u";
export var transparent = "_t-j";
export var warning = "_t-b";
export var wideNano = "_t-6";